import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=5df67e87&scoped=true&"
import script from "./Country.vue?vue&type=script&lang=js&"
export * from "./Country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df67e87",
  null
  
)

export default component.exports